import { makeStyles } from "@material-ui/core";
import React from "react";

import { FONT_HEAVY } from "../../styles/fonts";

interface SectionCardSubsectionProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  dataTestId?: string;
}

export default function SectionCardSubsection({
  title,
  children,
  className = "",
  dataTestId,
}: SectionCardSubsectionProps) {
  const classes = useStyles();
  return (
    <section
      className={`${classes.root} ${className}`}
      data-testid={dataTestId}
    >
      {title && <h4 className={classes.title}>{title}</h4>}
      {children}
    </section>
  );
}

const useStyles = makeStyles(() => ({
  root: {
    padding: "16px 0",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    "&:first-child": {
      paddingTop: 0,
    },
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  title: {
    fontSize: 16,
    lineHeight: "20px",
    margin: 0,
    ...FONT_HEAVY,
  },
}));
